import { ReactElement } from 'react';

import { Checkbox } from '@dreryk/react-components';
import { BindingCreator } from '@dreryk/react-common';

import { translationKeys } from '../../translations';

type CancelledVisitsVisibilityPreferenceFormBeanPart = {
   preferCancelledVisitsVisible: boolean;
};

type CancelledVisitsVisibilityPreferenceFieldProps = {
   register: BindingCreator<CancelledVisitsVisibilityPreferenceFormBeanPart, 'preferCancelledVisitsVisible'>;
};

export const CancelledVisitsVisibilityPreferenceField = (
   props: CancelledVisitsVisibilityPreferenceFieldProps
): ReactElement => (
   <Checkbox
      testId={'preferCancelledVisitsVisible'}
      controller={props.register('preferCancelledVisitsVisible')}
      label={translationKeys.showCancelled}
   />
);
